import dynamic from 'next/dynamic'

import { useIntl } from 'react-intl'

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  IconButton
} from '@mui/material'

import BackIconSvg from 'app/assets/icons/back-icon.svg'
import Box from 'app/components/base/Box'
import Button from 'app/components/base/Button'
import Stack from 'app/components/base/Stack'
import ClearAllProductsFilters from 'app/features/Store/Products/components/ClearAllProductsFilters'
import ProductsFields from 'app/features/Store/Products/components/ProductsFields'
import useProductsFiltersControl from 'app/hooks/useProductsFiltersControl'

const Logo = dynamic(() => import('app/assets/images/dark-logo.svg'))

type ProductsFilterDialogProps = Omit<DialogProps, 'onClose'> & {
  onClose: () => void
  partNumbers?: string[]
}

const ProductsFilterDialog: RFC<ProductsFilterDialogProps> = ({
  open,
  onClose,
  partNumbers,
  ...rest
}) => {
  const intl = useIntl()
  const { hasFilters } = useProductsFiltersControl<UserListingsParams>()

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper ': {
          '& .MuiDialogContent-root': {
            borderBottom: 'none'
          }
        }
      }}
      open={open}
      onClose={onClose}
      fullScreen
      scroll="paper"
      {...rest}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          px: 2,
          py: 2
        }}
      >
        <IconButton
          onClick={() => onClose()}
          sx={{ position: 'absolute', left: '8px' }}
        >
          <BackIconSvg />
        </IconButton>
        <Logo />
      </Box>

      <DialogContent
        sx={{
          px: 2,
          paddingBottom: 1
        }}
      >
        <ProductsFields partNumbers={partNumbers} />
      </DialogContent>

      <DialogActions
        sx={{
          p: 2,
          backgroundColor: 'background.dark',
          borderTop: '1px solid #D6DCE9'
        }}
      >
        {hasFilters ? (
          <Button variant="contained" onClick={onClose}>
            {intl.formatMessage({ defaultMessage: 'Apply' })}
          </Button>
        ) : (
          <Stack direction="row" spacing={2} sx={{ flex: 1 }}>
            <ClearAllProductsFilters
              sx={{ width: '100%' }}
              variant="outlined"
              onClick={onClose}
            />
            <Button variant="contained" onClick={onClose}>
              {intl.formatMessage({ defaultMessage: 'Apply Filters' })}
            </Button>
          </Stack>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default ProductsFilterDialog
